var map = {
	"./app-store.svg": 541,
	"./arrow-down.svg": 6292,
	"./arrow-right.svg": 8150,
	"./article-category.svg": 1023,
	"./article-date.svg": 2527,
	"./article-info.svg": 5211,
	"./article-views.svg": 7647,
	"./asr.svg": 6094,
	"./back.svg": 9050,
	"./burger.svg": 9499,
	"./close.svg": 6456,
	"./dhuhr.svg": 9767,
	"./facebook.svg": 376,
	"./fajr.svg": 4679,
	"./google-play.svg": 3812,
	"./instagram.svg": 1952,
	"./isha.svg": 1989,
	"./left.svg": 9583,
	"./live.svg": 7050,
	"./location.svg": 2177,
	"./maghrib.svg": 2042,
	"./mission-advise.svg": 5395,
	"./mission-check.svg": 4125,
	"./mission-document.svg": 5436,
	"./mission-register.svg": 776,
	"./mission-report.svg": 321,
	"./mission-security.svg": 4369,
	"./mission-touroperator.svg": 2745,
	"./plus.svg": 1796,
	"./right.svg": 8122,
	"./search.svg": 7928,
	"./share.svg": 3661,
	"./sli-home.svg": 7982,
	"./success.svg": 3421,
	"./sunrise.svg": 2509,
	"./twitter.svg": 7993,
	"./user.svg": 5733,
	"./website.svg": 7915,
	"./whatsapp.svg": 4294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;